import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Ajax from '../ajax/Ajax';

class Inspiratron extends Component {

    constructor(props) {
        super(props);
        this.state = {idx: false, inspiration: false, inspirations: false};
        this.refresh = this.refresh.bind(this);
    }

    componentWillMount() {
        var obj = this;
        Ajax.getInspiration().then((inspirations) => {
            console.log(inspirations);
            var idx = Math.min(inspirations.length - 1, Math.floor(Math.random() * 1000));
            var inspiration = inspirations[idx];
            obj.setState({inspirations: inspirations, idx: idx, inspiration: inspiration});
        })
    }

    refresh() {
        var inspirations = this.state.inspirations;
        var idx = Math.min(inspirations.length - 1, Math.floor(Math.random() * 1000));
        var inspiration = inspirations[idx];
        this.setState({idx: idx, inspiration: inspiration});
    }

	render() {
		return (
		<div className="Inspiratron">
			<div className="InspiratronNumber">
                {this.state.idx}
            </div>
            <div className="InspiratronContent" dangerouslySetInnerHTML={{__html: this.state.inspiration}}>
            </div>
            <div className="InspiratronRefresh" onClick={this.refresh}>Encore!</div>
		</div>
		);
	}
}

export default Inspiratron;


// WEBPACK FOOTER //
// ./src/components/Inspiratron.js